import { Skeleton } from "@mui/material";
import { styled } from "@mui/system";

const SkeletonCardStyle = styled(Skeleton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
}));

export const SkeletonCard: React.FC = () => (
  <>
    <SkeletonCardStyle variant="rectangular" height={200} />
    <SkeletonCardStyle variant="text" height={36} />
  </>
);
